import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookie from 'js-cookie';
import jwt from 'jsonwebtoken';
import PropTypes from 'prop-types';
import questionBg from '../../template/utils/images/questionBg.png';
import { ErrorAlertNotification } from '../commons/index';
import withdrawFixedSaving, { deleteWithdrawFixedSavingError } from '../../actions/savings.actions/withdrawFixedSavings';
import withdrawTargetSaving from '../../actions/savings.actions/withdrawTargetSavings';
import SelectAccountId from './SelectAccountId';

/**
 * @class WithDrawSavingOption
 */
class WithDrawSavingOption extends Component {
  withDrawToWallet = () => {
    const getSavingObj = Cookie.getJSON('savingObj');
    const token = Cookie.get('jwtToken');
    const decodeToken = jwt.decode(token);
    const { customerId } = decodeToken;
    const { WithdrawFixedSaving } = this.props;
    if (getSavingObj.planType === 'FIXED_SAVINGS' || getSavingObj.planType === 'ETHICAL_SAVINGS') {
      const fixedSavingsObj = {
        customerId: Number(customerId),
        fixedSavingId: getSavingObj ? Number(getSavingObj.id) : '',
        withdrawTo: 2
      };
      WithdrawFixedSaving(fixedSavingsObj);
    }
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  handleDelete = () => {
    const getSavingObj = Cookie.getJSON('savingObj');
    if (getSavingObj.planType === 'FIXED_SAVINGS' || getSavingObj.planType === 'ETHICAL_SAVINGS') {
      const { DeleteWithdrawFixedSavingError } = this.props;
      DeleteWithdrawFixedSavingError();
    }
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      fixedSavingLoading,
      fixedSavingError
    } = this.props;

    const withDrawSavingOption = (
      <div className="modal fade" id="ftop_settings">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close" data-dismiss="modal"
              >
                {' '}
                <span> Close </span>
                {' '}
&times;
              </button>
            </div>

            <div className="modal-body p-5">
              <div className="first_step">
                <div className="ques_info">
                  <img src={questionBg} alt="" />
                </div>
                {
                fixedSavingError ? (
                  <ErrorAlertNotification
                    errors={fixedSavingError}
                    onClick={this.handleDelete}
                  />
                ) : ''
              }
                <div className="have_stock_acc">
                  <p>
                      Choose your preferred withdrawal destination..
                  </p>
                </div>

                <div className="have_stock_acc_answer">

                  <div className="wallet_button mr-3" style={{
                    backgroundColor: '#99BF16',
                    borderRadius: '4px',
                  }}
                  >
                    {
                    fixedSavingLoading ? (
                      <button
                        type="button"
                        style={{
                          color: '#ffff'
                        }}
                        onClick={this.withDrawToWallet}
                      >
                        <i className="fa fa-spinner fa-spin" />
                        {'  '}
                    Wallet
                      </button>
                    ) : (
                      <button
                        type="button"
                    // data-dismiss="modal"
                        style={{
                          color: '#ffff'
                        }}
                        onClick={this.withDrawToWallet}
                      >
                    Wallet
                      </button>
                    )
                  }
                  </div>
                  <div className="ans_yes">
                    <button
                      type="button" id="yes_i_do"
                      data-toggle="modal"
                      data-target="#select_account"
                      data-dismiss="modal"
                    >
                      <span style={{ color: 'white' }}>Bank Account</span>
                    </button>
                  </div>

                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    );
    return (
      <>
        { withDrawSavingOption }
        <SelectAccountId />
      </>
    );
  }
}

WithDrawSavingOption.propTypes = {
  DeleteWithdrawFixedSavingError: PropTypes.string,
  WithdrawFixedSaving: PropTypes.func,
  fixedSavingLoading: PropTypes.bool,
  fixedSavingError: PropTypes.string
};

const mapStateToProps = state => ({
  fixedSavingLoading: state.WithdrawFixedSavings.loading,
  fixedSavingError: state.WithdrawFixedSavings.error,
});

export default connect(mapStateToProps, {
  WithdrawFixedSaving: withdrawFixedSaving,
  DeleteWithdrawFixedSavingError: deleteWithdrawFixedSavingError,
  WithdrawTargetSaving: withdrawTargetSaving
})(WithDrawSavingOption);
